import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import CreateUser from './createUser';
import apiService from '../services/api.service';
import { appPath } from '../utils/appSlug';
import { formatRomeDateTime } from '../utils/datetime';

export default function EventRegistration({ appSlug, loginStatus = {} }) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const hasEvent = query.has('event');
  const uid = query.get('event') || '';
  const session = loginStatus.sub;
  const verified = loginStatus.is_verified !== false;
  const role = loginStatus.platform_role;
  const [state, setState] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const key = `${appSlug}:${uid}:${session || ''}:${verified}`;

  useEffect(() => {
    if (!hasEvent) return undefined;
    let active = true;
    setError('');
    async function load() {
      if (!uid) {
        setState({ key, error: 'Link di iscrizione non disponibile.' });
        return;
      }
      try {
        const { data: event } = await apiService.getPublicEventRegistration(appSlug, uid);
        if (!event?.id || !event?.name) throw new Error('Invalid event');
        let registered = false;
        if (session && verified && !event.finished && role === 'utente_base') {
          try {
            const { data } = await apiService.getEventRegistration(event.id);
            registered = data.registered;
          } catch {
            if (active) setState({ key, event, error: 'Impossibile verificare la tua iscrizione. Ricarica la pagina per riprovare.' });
            return;
          }
        }
        if (active) setState({ key, event, registered });
      } catch {
        if (active) setState({ key, error: 'Link di iscrizione non disponibile. Verifica il link ricevuto.' });
      }
    }
    load();
    return () => { active = false; };
  }, [hasEvent, appSlug, uid, session, verified, role, key]);

  if (!hasEvent) return <CreateUser appSlug={appSlug} />;
  if (state.key !== key) return <p role="status">Caricamento evento...</p>;
  const event = state.event;
  if (!session && event && !event.finished && !state.error) {
    return <CreateUser key={key} appSlug={appSlug} eventUid={uid} eventName={event.name} />;
  }
  const enroll = async () => {
    setBusy(true);
    setError('');
    try {
      await apiService.registerForEvent(event.id);
      setState((previous) => ({ ...previous, registered: true }));
    } catch (err) {
      setError(err.response?.status === 409
        ? 'Le iscrizioni a questo evento sono chiuse.'
        : 'Iscrizione non riuscita. Riprova tra qualche istante.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page"><div className="login-card">
      <p className="login-kicker">Iscrizione evento</p>
      <h1 className="login-title">{event?.name || 'Iscrizione evento'}</h1>
      {event && <p className="login-subtitle">{formatRomeDateTime(event.date)}</p>}
      {state.error ? <Alert variant="danger">{state.error}</Alert>
        : event.finished ? <Alert variant="info">Le iscrizioni a questo evento sono chiuse.</Alert>
        : !verified ? <Alert variant="info">Verifica il tuo account tramite l’email ricevuta prima di iscriverti.</Alert>
        : role !== 'utente_base' ? <Alert variant="info">Accedi con un account partecipante per iscriverti a questo evento.</Alert>
        : state.registered ? <Alert variant="success">Sei iscritto a questo evento.</Alert>
        : <><p>Conferma l’iscrizione utilizzando il tuo account.</p>
          <Button className="login-submit" onClick={enroll} disabled={busy}>
            {busy ? 'Iscrizione in corso...' : 'Iscriviti all’evento'}
          </Button></>}
      {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
      <p className="login-register-prompt mt-3"><Link to={appPath(appSlug)}>Torna al sito</Link></p>
    </div></div>
  );
}
